import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { AbstractConstructor, ExtensionInterface } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitMetadataExtensionInterface } from '../../extension/interface/benefit-metadata.extension.interface';

export * from './ActivationDialog';
export * from './ActivationsList';
export { NavBenefitList } from './nav/NavBenefitList';

export function getExtensionForBenefit<T extends ExtensionInterface>(
  benefit: BenefitDTOBenefitEnum,
  extensionInterface: AbstractConstructor<T>,
) {
  const keyedBenefitMetadataExtensions = EXTENSIONS.getKeyedProviders(BenefitMetadataExtensionInterface);

  const extensionKey = keyedBenefitMetadataExtensions.find(({ provider }) => provider.benefitId === benefit)?.key;

  return EXTENSIONS.getProviderByKey(extensionKey, extensionInterface);
}
